/** Компонента редактирование значений http://www.w3.org/ns/dcat#themeTaxonomy
 * 
 * Формирует список доступных ссылок на skos:ConceptScheme 
 * с кнопками:
 * - "Удалит"ь ссылку. По кнопке удаляется триплет с ссылкой.
 * - "Связать" с объектом. По кнопке "Связать" отображается диалог выбора объекта. 
 *  По Ok создаётся триплет с ссылкой
 * - "Создать". По кнопке создаётся новая skos:ConceptScheme и создаётся триплет с ссылкой.
*/
import React from 'react';
import i18n from "i18next";
import { connect } from 'react-redux';
import { Tooltip, Button, Modal, message } from 'antd';
import { LinkOutlined, FileAddOutlined, DisconnectOutlined } from '@ant-design/icons'
import { AdmsRepository, OwlRepository, RdfTriplet } from '../../redux';
import { SimpleViewLinkComponent } from '../widgets/ViewLink';
import SelectIndividualForm from './SelectIndividualForm';
import NewElement from './NewElement';
import { makeHashLastInURI, parseFileNameFromURL} from '../../utils/uriUtil';

const ButtonGroup = Button.Group;
const { confirm } = Modal;

/** Отображение диалога с выбором индивидуала для установки связи.
 * selected - URI выбранного элемента
 */
const showSelectIndividual = (subject, predicat, formRef=f=>f, factory, onFinishOperation=f=>f, onCancelOperation=f=>f, selected) => {
  console.log("ObjectPropertyEditor.js showSelectConceptScheme", subject);
  const isURI = (selected) && (selected.value);
  const okButtonProps={disabled: !isURI};
  return (
    <Modal 
      style={{minWidth: 700}} open={true} 
      title={i18n.t('components.editor.individual.select.title')}
      cancelText={i18n.t('components.editor.individual.select.cancelText')} 
      okText={i18n.t('components.editor.individual.select.okText')} 
      onCancel={onCancelOperation} 
      onOk={onFinishOperation} 
      okButtonProps={okButtonProps}>	
        <SelectIndividualForm           
          formRef={formRef} 
          factory={factory} 
          IRI={subject}
          predicat = {predicat}
        />
	  </Modal>
    )
}

/**
 * Отобразить диалог для создания нового распространения.
 * Варианты заполнение 1-запрос к EndPoint, 2-имя файла:
 * 1. Формирование URI на основе URI карточки с добавлением #Distribution+Текущая дата и время
 *    Формирование наименование "SPARQL запрос"
 *    Формирование accessURL на основе настройки virtuoso+SPARQL (construct {?s ?p ?o} where {?s ?p ?o})+имя графа в виде URI карточки
 *    Формирвоание описание с содержимым SPARQL
 * 2. Формирование URI на основе URI карточки с добавлением #+имя файла
 *    Формирование наименование на основе имени файла
 * 
 * Проверка на основе двух полей (accessURL и downloadURL)
 * https://stackoverflow.com/questions/70067400/manually-validate-antd-form-field-against-another-field
 * 
 * graph - iri графа, который содержит данные
 */
 const showNew = (formRef=f=>f, rdfTypes, factory, onFinishOperation=f=>f, onCancelOperation=f=>f, assetURI) => {
  const rdfType = (Array.isArray(rdfTypes) && rdfTypes.length>0)? rdfTypes[0]: 'http://www.w3.org/2002/07/owl#NamedIndividual';
	return (
    <Modal style={{minWidth: 700}} open={true} 
        title={i18n.t('components.editor.individual.new.title')}
        cancelText={i18n.t('components.editor.individual.new.cancelText')}
        okText={i18n.t('components.editor.individual.new.okText')} 
        onCancel={onCancelOperation} onOk={onFinishOperation}>	
        <NewElement 
          formRef={formRef} 
          factory={factory} 
          rdfType={rdfType} 
          rdfTypes={rdfTypes}
          prefixURI={makeHashLastInURI(assetURI)}
          />
	  </Modal>
  )
}


/** Форма редактирования ссылочного значения */
class ObjectPropertyEditor extends React.Component {

  state = {
    loading: false,
    modal: "none",		//Состояние модельного окна. none - не показывается, 
      //link - отобразить диалог выбора элемента
      //new - диалог создания элемента,
    rdfTypes: [],
  }
  
  formRef = React.createRef();

  componentDidMount() {
    // To disable submit button at the beginning.
    //this.props.form.validateFields();
  }

  cancelOperation(){
    this.setState({modal:"none"});
  }

  /** Запускает установку связи */
  submitLinkOperation() {
    const { subject, predicat, vselected, onInsertProperty, onReload} = this.props;
    //console.log("ObjectPropertyEditor.js submitLinkOperation()", subject, predicat, vselected);
    //Свяжем с каталогом
    onInsertProperty(RdfTriplet, subject, predicat, vselected.value)
      .then (result =>{
      //console.log("ObjectPropertyEditor.js submitLinkOperation()() result", result);
      //Обновим каталог
      if (onReload)
        onReload(subject, predicat).then(result2=> {
          //console.log("ObjectPropertyEditor.js submitNewOperation() result2", result2);
          message.success(i18n.t('components.editor.individual.message.ok_link'));
          this.setState({modal:"none"});
        });
      else {
        message.success("Для просмотра изменений перегрузите страницу.");
        this.setState({modal:"none"});
      };
  });
};


  /** Запускает добавление нового элемента классификатора и установка связи */
  submitNewOperation() {
    const { subject, predicat, onNewElement, onInsertProperty, onReload} = this.props;
    const form  = this.formRef.current;      
    form.validateFields()
      .then( values => {
        const IRI = (values.IRI.startsWith("http://") || values.IRI.startsWith("https://"))? values.IRI : "http://www.w3.org/ns/dcat#"+values.IRI;
        const label = values["http://www.w3.org/2000/01/rdf-schema#label"];
        const rdfType = values["http://www.w3.org/1999/02/22-rdf-syntax-ns#type"];
        //console.log("ObjectPropertyEditor.js submitNewOperation()", subject, predicat, IRI, label);
        Promise.all([
          //Создадим элемент (Тип в values)
          onNewElement(AdmsRepository, IRI, rdfType, label.text, label.lang),
          //Свяжем с каталогом
          onInsertProperty(RdfTriplet, subject, predicat, IRI),
        ]).then (result =>{
          //console.log("ObjectPropertyEditor.js submitNewOperation() result", result);
          //Обновим каталог
          if (onReload)
            onReload(subject, predicat).then(result2=> {
              //console.log("ObjectPropertyEditor.js submitNewOperation() result2", result2);
              message.success(i18n.t('components.editor.individual.message.ok_new'));
            });
          else{
            message.success("Для просмотра изменений перегрузите страницу.");
          };
        });
        this.setState({modal:"none"});
      })
    .catch(info => {
      console.log("ObjectPropertyEditor.js submitNewOperation() Received info of form: ", info);
      message.error(i18n.t('components.editor.individual.message.e_new', {detail: info}));
      //this.setState({modal:"none"});
    });
  };

  onAction (e, type, item) {
    //console.log("ObjectPropertyEditor.js onAction", this, type, item);
    e.preventDefault();
    if (type == 'link'){
      const { action, predicat, onEmptySelect} = this.props;
      Promise.all([onEmptySelect(RdfTriplet)])
      .then (result => {
        this.setState({modal:"link"});
        if (action)
          action(e, type, predicat);
      });
    };
    if (type == "new"){
      const { action, predicat, onRange } = this.props;
      onRange(OwlRepository, predicat)
        .then(response => {
          if (action)
            action(e, type, predicat);
          const rdfTypes = response.types.map(item => item.object.value);
          //console.log("ObjectPropertyEditor.js onAction (e, type, item)", predicat , response, rdfTypes);
          this.setState({modal:"new", rdfTypes});  
      });
    }
    if (type=="unlink"){
      this.setState({modal:"none"});
      const { action, subject, predicat, onDeleteElement, onReload} = this.props;
      if (action)
        action(e, type, predicat);
      confirm(
        { 
          title: 'Разорвать связь с выбранным классификатором', 
          content: item.object.value, 
          okText: 'Да', 
          okType: 'danger', 
          cancelText: 'Нет',
          onOk() { 
            onDeleteElement(RdfTriplet, subject, predicat, item.object.value)
            .then (result =>{
              //Обновим каталог
              if (onReload)
                onReload(subject, predicat).then(result2=> {});
              else  
                message.success("Для просмотра изменений перегрузите страницу.");
            })
            .catch(info => {
              message.error(i18n.t('components.editor.individual.message.e_unlink', {detail: info}));
              //this.setState({modal:"none"});
            });
          },
          onCancel() {},
        });
        return;      
      };
  };

  render() {
    const { lang, values, uri, predicat, subject, factory } = this.props;
    const { modal, rdfTypes } = this.state;
    return (
      <span>
        <ButtonGroup>
          <Tooltip placement="top" title={"Связать"}>
            <Button type="dashed" size="small" icon={<LinkOutlined />} onClick={(e)=> this.onAction(e, "link")} />
          </Tooltip>
          { (modal=="link" ) && 
            showSelectIndividual(subject, predicat, this.formRef, factory, ()=>this.submitLinkOperation(), ()=>this.cancelOperation(), this.props.vselected)
          }
          <Tooltip placement="top" title={"Создать новый экземпляр"}>
            <Button type="dashed" size="small" icon={<FileAddOutlined />} onClick={(e)=> this.onAction(e, "new")} style={{display: "none"}}/>
          </Tooltip>
          { (modal=="new" ) && 
            showNew(this.formRef, rdfTypes, factory, ()=>this.submitNewOperation(), ()=>this.cancelOperation(), subject)
          }
        </ButtonGroup>
        <br />
        {values.map((item, i) => 
          <span key={item.object.value}>
            <Tooltip placement="top" title={"Разорвать связь"}>
              <Button type="dashed" size="small" icon={<DisconnectOutlined />} onClick={(e)=> this.onAction(e, "unlink", item)}/>
            </Tooltip>            
            <SimpleViewLinkComponent IRI={item.object.value} factory={factory}  triplet={item} lang={lang}/>
          <br/>
          </span>
        )}
      </span>
    );
  };  
};

function mapStateToProps(state, props) {
  const {vselected} = state;
  return {
      vselected
  };
}

export default connect(
  mapStateToProps,
  dispatch => ({
    onNewElement (actions, iri, type, label, lang){
      return dispatch(actions.addElementSimple(iri, type, label, lang));
    },    
    onDeleteElement (actions, subject, predicat, object){
      return dispatch(actions.deleteTripleURI(subject, predicat, object));
    },
    onInsertProperty(actions, subject, predicat, uri){
      return dispatch(actions.insertTripleURI(subject, predicat, uri));
    },
    onRealod(actions){
      return dispatch(actions.loadCatalogDetails());
    },
    onEmptySelect(actions){
      return dispatch(actions.EMPTY());
    },
    onRange(actions, predicat) {
      return dispatch(actions.loadRange(predicat));
    }
  })
)(ObjectPropertyEditor);